module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [(_vm.billInfo) ? _c('div', {
    staticClass: "hd research-background-color"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v(_vm._s(_vm.billInfo.year) + "年账单")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('BillList', {
    attrs: {
      "billInfo": _vm.billInfo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7af27be2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupBill/AnnualBillDetail.vue
// module id = 1679
// module chunks = 8